import { render } from "./HeadGrid.vue?vue&type=template&id=a2446c86"
import script from "./HeadGrid.vue?vue&type=script&lang=js"
export * from "./HeadGrid.vue?vue&type=script&lang=js"

import "./HeadGrid.vue?vue&type=style&index=0&id=a2446c86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__